import Vue from 'vue';
import numeral from 'numeral'

Object.defineProperty(Vue.prototype, 'numeral', { value: numeral });

numeral.register('locale', 'nl', {
    delimiters: {
        thousands: '.',
        decimal: ','
    }
});

numeral.locale('nl');
